<template>
    <div class="col-12 px-0 mx-0">
        <b-col md="12" class="px-0 col-12">
            <b-row>
                <div ref="topScroll" class="top-scrollbar-wrapper" @scroll="syncScroll('top')">
                    <div class="top-scrollbar-content" :style="{ width: scrollWidth + 'px' }"></div>
                </div>

                <div class="table-responsive mb-0" ref="tableScroll" @scroll="syncScroll('table')">

                    <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                        class="table table-bordered table-sm" v-if="readPermission == true">
                        <template #cell(isActive)="data">
                            <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                :disabled="updateStatusPermission == false" v-model="tableRows[data.index].isActive"
                                switch class="mb-1">
                            </b-form-checkbox>
                        </template>

                        <template #cell(brand)="data">
                            <span>{{ tableRows[data.index].brand?.name }}</span>
                        </template>

                        <template #cell(remark)="data">
                            <span>{{ tableRows[data.index].remark || '--' }}</span>
                        </template>

                        <template #cell(referenceNumber)="data">
                            <span>{{ tableRows[data.index].referenceNumber || '--' }}</span>
                        </template>

                        <template #cell(dor)="data">
                            <span>{{ tableRows[data.index].dor || '--' }}</span>
                        </template>

                        <template #cell(form)="data">
                            <span>{{ tableRows[data.index].form?.name || '--' }}</span>
                        </template>

                        <template #cell(class)="data">
                            <span>{{ tableRows[data.index].class?.name || '--' }}</span>
                        </template>

                        <template #cell(endorseLabelArray)="data">
                            <b-badge v-for="(item, index) of tableRows[data.index].endorseLabelArray" :key="index"
                                variant="info" class="ml-1">
                                <p class="font-size-16 my-0">{{ item }}</p>
                            </b-badge>
                        </template>

                        <template #cell(type)="data">
                            <span>{{ tableRows[data.index].type?.name || '--' }}</span>
                        </template>

                        <template #cell(approvalDate)="data">
                            <div class="text-center">
                                <span>{{ tableRows[data.index].approvalDate || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(purpose)="data">
                            <div class="text-center">
                                <span>{{ tableRows[data.index].purpose?.name || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(dossierSubmissionDate)="data">
                            <div class="text-center">
                                <span>{{ tableRows[data.index].dossierSubmissionDate || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(shelfLifeTime)="data">
                            <div class="text-center">
                                <span>{{ tableRows[data.index].shelfLifeTime || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(isRegisterCert)="data">
                            <div class="text-center">
                                <b-badge :variant="tableRows[data.index].isRegisterCert ? 'info' : 'secondary'">
                                    {{ tableRows[data.index].isRegisterCert ? $t('label.yes') : $t('label.no') }}
                                </b-badge>
                            </div>
                        </template>

                        <template #cell(productQuery)="data">
                            <div class="text-center">
                                <span>{{
                                    formatDateNumeric(tableRows[data.index].productQuery[tableRows[data.index].productQuery.length
                                        - 1]?.date)
                                    || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(productPrinterProof)="data">
                            <div class="text-center">
                                <span>{{
                                    formatDateNumeric(tableRows[data.index].productPrinterProof[tableRows[data.index].productPrinterProof.length
                                        - 1]?.date)
                                    || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(productPayment)="data">
                            <div class="text-center">
                                <span>{{
                                    formatDateNumeric(tableRows[data.index].productPayment[tableRows[data.index].productPayment.length
                                        - 1]?.date)
                                    || '--' }}</span>
                            </div>
                        </template>

                        <template #cell(expiredDate)="data">
                            <b-badge pill :variant="getVariant(tableRows[data.index].expiredDate)">
                                {{ tableRows[data.index].expiredDate }}
                            </b-badge>
                        </template>

                        <template #cell(status)="data">
                            <b-badge pill variant="primary"
                                v-if="tableRows[data.index].status.uuid != '58380ab4-67a4-40ee-9860-7d5ba78f965f'">
                                {{ tableRows[data.index].status?.name }}
                            </b-badge>
                            <b-badge pill variant="warning" v-else>
                                {{ tableRows[data.index].status?.name }}
                            </b-badge>
                        </template>

                        <template #cell(productAI)="data">
                            <div v-if="data.item.productAI && data.item.productAI.length" class="d-flex flex-column">
                                <div v-for="(ai, index) in data.item.productAI" :key="index"
                                    class="font-size-13 text-muted text-nowrap">
                                    {{ ai.rnd_active_ingredient?.name }}
                                    <span v-if="ai.concentration">
                                        - {{ ai.concentration }}% w/w
                                    </span>
                                </div>
                            </div>
                            <span v-else>--</span>
                        </template>

                        <template #cell(productSource)="data">
                            <div class="d-flex flex-column">
                                <div v-for="(item, index) in tableRows[data.index].productSource" :key="index"
                                    class="rounded mb-1 bg-light px-2">
                                    {{ item.source?.name }}
                                </div>
                            </div>
                            <div class="text-center">
                                <span v-if="tableRows[data.index].productSource.length == 0">--</span>
                            </div>
                        </template>

                        <template #cell(rndProductMoa)="data">
                            <div class="d-flex flex-column">
                                <div v-for="(item, index) in tableRows[data.index].rndProductMoa" :key="index"
                                    class="rounded mb-1 bg-light px-2">
                                    {{ item?.moa?.name }}
                                </div>
                            </div>
                            <div class="text-center">
                                <span v-if="tableRows[data.index].rndProductMoa.length == 0">--</span>
                            </div>
                        </template>
<!-- 
                        <template #cell(productLabel)="data">
                            <div class="d-flex flex-column gap-1">
                                <div v-for="(item, index) in tableRows[data.index].productLabel" :key="index"
                                    class="border rounded px-2 bg-light mb-1">
                                    <div class="font-size-14 text-muted text-nowrap">
                                        <span class="font-weight-bold">{{ $t('label.date') }}:</span>
                                        {{ formatDateNumeric(item?.date) }}
                                    </div>
                                    <div class="font-size-14 text-muted text-nowrap">
                                        <span class="font-weight-bold">{{ $t('label.packagingMaterial') }}:</span>
                                        {{ item?.packaging_material || '--' }}
                                    </div>
                                    <div class="font-size-14 text-muted text-nowrap">
                                        <span class="font-weight-bold">{{ $t('label.xSize', []) }}:</span>
                                        {{ item?.sizes?.join(', ') || '--' }}
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <span v-if="tableRows[data.index].productLabel.length == 0">--</span>
                            </div>
                        </template> -->

                        <!-- <template #cell(rndProductNewLabels)="data">
                            <div class="col-12">
                                <div class="d-flex flex-column gap-1">
                                    <div
                                        v-for="(item, index) in tableRows[data.index].rndProductNewLabels"
                                        :key="index"
                                        class="border rounded px-2 bg-light mb-1"
                                    >
                                        <div class="font-size-14 text-muted text-nowrap">
                                            <span class="font-weight-bold">{{ $t('label.date') }}:</span>
                                            {{ formatDateNumeric(item?.date) }}
                                        </div>
                                        <div
                                            v-for="(i, j) in item?.labels"
                                            :key="j"
                                            class="font-size-14 text-muted text-nowrap border border-secondary rounded px-2 mb-1"
                                        >
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.packagingMaterial') }}:</span>
                                                {{ i?.packagingMaterial || '--' }}
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.xSize', []) }}:</span>
                                                {{ i?.size || '--' }}
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.remark') }}:</span>
                                                {{ i?.remark || '--' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <span v-if="tableRows[data.index].rndProductNewLabels.length == 0">--</span>
                                </div>
                            </div>
                        </template> -->

                        <template #cell(rndProductNewLabels)="data">
                            <div class="col-12">
                                <div class="d-flex flex-column gap-1">
                                    <div
                                        v-for="(item, index) in tableRows[data.index].rndProductNewLabels"
                                        :key="index"
                                        class="border rounded px-2 bg-light mb-1"
                                    >
                                        <div class="font-size-14 text-muted text-nowrap">
                                            <span class="font-weight-bold">{{ $t('label.date') }}:</span>
                                            {{ formatDateNumeric(item?.date) }}
                                        </div>
                                        <div
                                            v-for="(i, j) in item?.labels"
                                            :key="j"
                                            class="font-size-14 text-muted text-nowrap border border-secondary rounded px-2 mb-1"
                                        >
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.packagingMaterial') }}:</span>
                                                {{ i?.packagingMaterial || '--' }}
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.xSize', []) }}:</span>
                                                {{ i?.size || '--' }}
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('label.remark') }}:</span>
                                                {{ i?.remark || '--' }}
                                            </div>
                                            <div v-if="i.images.length > 0">
                                                <span class="font-weight-bold">{{ $t('label.image') }} ({{ i.images.length }}): </span>
                                                <b-badge
                                                    variant="primary cursor-pointer"
                                                    v-on:click="$bvModal.show('product_labels_image_modal_'+i.uuid)"
                                                >
                                                    {{ $t('label.viewX', []) }}
                                                </b-badge>
                                                <b-modal
                                                    :id="'product_labels_image_modal_'+i.uuid"
                                                    :title="$t('label.image')"
                                                    size="lg"
                                                    centered
                                                    hide-header-close
                                                >
                                                    <div class="row">
                                                        <div v-for="(img, imgIndex) in i.images" :key="imgIndex" class="col-4 mb-2">
                                                            <a :href="img.imageUrl" target="_blank" class="cursor-pointer">
                                                                <img
                                                                    :src="img.imageUrl"
                                                                    class="img-thumbnail img-fluid"
                                                                    style="width: 100%; aspect-ratio: 1 / 1; object-fit: cover; border-radius: 4px;"
                                                                    :title="$t('label.viewX', [])"
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <template #modal-footer>
                                                        <b-button variant="secondary" v-on:click="$bvModal.hide('product_labels_image_modal_'+u.uuid)">
                                                            {{ $t('label.cancel') }}
                                                        </b-button>
                                                    </template>
                                                </b-modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <span v-if="tableRows[data.index].rndProductNewLabels.length == 0">--</span>
                                </div>
                            </div>
                        </template>

                        <template #cell(productRecommendation)="data">
                            <div class="d-flex flex-column">
                                <div v-for="(item, index) in tableRows[data.index].productRecommendation" :key="index"
                                    class="border rounded px-2 bg-light mb-1">
                                    <div class="text-primary text-nowrap">
                                        {{ item?.remark }}
                                    </div>
                                    <div v-for="(crop, i) in item?.crops" :key="i" class="ml-2 mb-1">
                                        <div class="font-size-13 text-muted text-nowrap">
                                            <span class="font-weight-bold text-nowrap">{{ $t('module.crop') }}:</span>
                                            {{ crop.name }}
                                        </div>

                                        <div class="font-size-13 text-muted">
                                            <span class="font-weight-bold text-nowrap">{{ $t('label.pest') }}:</span>
                                            {{crop.pest_controls?.map(p => `${p.pest_control} (${p.rate})`).join(', ')
                                                || '--'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <span v-if="tableRows[data.index].productRecommendation.length == 0">--</span>
                            </div>
                        </template>

                        <template #cell(action)="data">
                            <a href="javascript:void(0);" class="mr-3"
                                :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                @click="toReportDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover="{
                                    title: 'Detail',
                                    placement: 'top',
                                    boundary: 'viewport',
                                    offset: '0,10',
                                    customClass: 'tt-no-block'
                                }" v-if="readPermission == true && updatePermission == true">
                                <i class="mdi mdi-file-document-outline font-size-18"></i>
                            </a>


                            <a href="javascript:void(0);" class="mr-3"
                                :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover="{
                                    title: 'Edit',
                                    placement: 'top',
                                    boundary: 'viewport',
                                    offset: '0,10',
                                    customClass: 'tt-no-block'
                                }" v-if="readPermission == true && updatePermission == true">
                                <i class="mdi mdi-pencil font-size-18"></i>
                            </a>

                            <a href="javascript:void(0);" class="mr-3"
                                :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover="{
                                    title: 'Read',
                                    placement: 'top',
                                    boundary: 'viewport',
                                    offset: '0,10',
                                    customClass: 'tt-no-block'
                                }" v-if="readPermission == true && updatePermission != true">
                                <i class="mdi mdi-file-document-outline font-size-18"></i>
                            </a>

                        </template>

                    </b-table>

                    <div style="text-align: center;" v-else>
                        {{ $t('message.noPermissionMessage') }}
                    </div>
                </div>
            </b-row>
        </b-col>
    </div>
</template>
<script>
import i18n from "@/i18n";
import { filtersHelper } from '@/utils'

export default {
    props: {
        tableRows: {
            type: Array,
            required: false,
        },
        perPage: {
            type: Number,
            required: true,
        },
        readPermission: {
            type: Boolean,
            required: true,
        },
        updatePermission: {
            type: Boolean,
            required: true,
        },
        updateStatusPermission: {
            type: Boolean,
            required: true,
        },
        currentUser: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            scrollWidth: 0,
            fields: [
                {
                    key: "brand",
                    sortable: true,
                    label: i18n.t("module.company"),
                    // Add 'sticky-col' and 'col-1'
                    thClass: 'sticky-col col-1',
                    tdClass: 'sticky-col col-1'
                },
                {
                    key: "status",
                    sortable: false,
                    label: i18n.t("module.status"),
                    // Add 'sticky-col' and 'col-2'
                    thClass: 'sticky-col col-2',
                    tdClass: 'sticky-col col-2'
                },
                {
                    key: "name",
                    sortable: true,
                    label: i18n.t("label.name"),
                    // Add 'sticky-col' and 'col-3'
                    thClass: ' sticky-col col-3',
                    tdClass: ' sticky-col col-3'
                },
                { key: "productAI", sortable: true, label: i18n.t("module.productAI"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "form", sortable: false, label: i18n.t("module.form"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "type", sortable: false, label: i18n.t("module.type"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "lrmp", sortable: true, label: i18n.t("label.lrmp"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "referenceNumber", sortable: true, label: i18n.t("label.XreferenceNumber", []), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "dor", sortable: true, label: i18n.t("label.dor"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "expiredDate", sortable: true, label: i18n.t("label.XexpiredDate", []), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "shelfLifeTime", sortable: true, label: i18n.t("label.shelfLifeTime"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "class", sortable: true, label: i18n.t("module.class"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "endorseLabelArray", sortable: true, label: i18n.t("label.endorseLabel"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "productSource", sortable: false, label: i18n.t("module.productSource", []), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "isRegisterCert", sortable: true, label: i18n.t("label.isRegisterCert"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "remark", sortable: true, label: i18n.t("label.remark", []), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "rndProductMoa", sortable: true, label: i18n.t("module.moa"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                // { key: "productLabel", sortable: true, label: i18n.t("module.productLabel"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "rndProductNewLabels", sortable: true, label: i18n.t("module.productLabel"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "productRecommendation", sortable: true, label: i18n.t("module.recommendation"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "purpose", sortable: true, label: i18n.t("label.purpose", []), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "dossierSubmissionDate", sortable: true, label: i18n.t("label.dorSubmissionDate"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "productQuery", sortable: true, label: i18n.t("module.query"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "productPrinterProof", sortable: true, label: i18n.t("module.printerProof"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "productPayment", sortable: true, label: i18n.t("module.productPayment"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "approvalDate", sortable: true, label: i18n.t("label.approvalDate"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "isActive", sortable: true, label: i18n.t("label.recordStatus"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
                { key: "Action", sortable: false, label: i18n.t("label.action"), thClass: 'text-nowrap', tdClass: 'text-nowrap' },
            ],
        };
    },
    mounted() {
        // Calculate scroll width after the table renders
        this.$nextTick(() => {
            this.updateScrollWidth();
            // Optional: Listen for window resize to adjust width
            window.addEventListener('resize', this.updateScrollWidth);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScrollWidth);
    },
    updated() {
        // Recalculate if data changes (rows added/removed)
        this.updateScrollWidth();
    },
    methods: {
        getVariant(expiredDate) {
            if (!expiredDate) return 'secondary'; // fallback if date is missing

            const today = new Date();
            const expiry = new Date(expiredDate);
            const diffTime = expiry - today;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays < 0) {
                return 'danger'; // expired
            } else if (diffDays <= 183) { // ~6 months
                return 'yellow'; // expiring within 6 months
            } else {
                return 'primary'; // valid
            }
        },
        formatDateNumeric(date) {
            return filtersHelper.getDateFormat(date);
        },
        toDetailsPage(data) {
            this.$emit("toDetailsPage", data);
        },
        editStatus(data) {
            this.$emit("editStatus", data);
        },
        toReportDetailsPage(data) {
            this.$emit("toReportDetailsPage", data);
        },
        updateScrollWidth() {
            const tableEl = this.$refs.tableScroll;
            if (tableEl) {
                // Get the full scrolling width of the real table
                this.scrollWidth = tableEl.scrollWidth;
            }
        },
        syncScroll(source) {
            const top = this.$refs.topScroll;
            const table = this.$refs.tableScroll;

            if (!top || !table) return;

            // If user scrolls the top bar, move the table
            if (source === 'top') {
                table.scrollLeft = top.scrollLeft;
            }
            // If user scrolls the table, move the top bar
            else if (source === 'table') {
                top.scrollLeft = table.scrollLeft;
            }
        }
    }
}
</script>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}

.badge-yellow {
    background-color: goldenrod;
    color: #fff;
}

::v-deep .sticky-col {
    position: sticky !important;
    position: -webkit-sticky !important;
    z-index: 2;
    background-color: #ffffff;
}

::v-deep th.sticky-col {
    z-index: 3;
    background-color: #f8f9fa;
    box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.1);
}

::v-deep .col-1 {
    left: 0;
    width: 160px;
    min-width: 160px;
    max-width: 160px;
}

/* Column 2: Status */
::v-deep .col-2 {
    left: 160px;
    width: 190px;
    min-width: 190px;
    max-width: 190px;
}

/* Column 3: Status */
::v-deep .col-3 {
    left: 350px;
    width: 250px;
    min-width: 150px;
    max-width: 100%;
    
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    position: sticky;
    z-index: 9;
    background-color: white; /* covers the table behind */
}

/* Add a pseudo-element for visible border */
::v-deep .col-3::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;            /* thickness of border */
    height: 100%;
    background-color: #ccc; /* grey border */
    pointer-events: none;   /* ensures it doesn’t block clicks */
    z-index: 11;            /* above everything else */
}

/* Optional: Make it more responsive on smaller screens */
@media (max-width: 768px) {
    ::v-deep .col-3 {
        width: 180px;
        min-width: 120px;
    }
}

.top-scrollbar-wrapper {
    width: 100%;
    overflow-x: auto;
    /* Allows horizontal scrolling */
    overflow-y: hidden;
    height: 20px;
    /* Height of the scrollbar area */
    margin-bottom: 0px;
    /* Connect it visually to the table */
}

/* Inner spacer to force the scrollbar to appear */
.top-scrollbar-content {
    height: 1px;
    /* Invisible spacer */
}

/* Ensure the bottom table container still looks good */
.table-responsive {
    overflow-x: auto;
    max-height: 70vh;
    /* Or your preferred height */
}

/* Optional: Make scrollbars look matching and distinct */
.top-scrollbar-wrapper::-webkit-scrollbar,
.table-responsive::-webkit-scrollbar {
    height: 12px;
}

.top-scrollbar-wrapper::-webkit-scrollbar-thumb,
.table-responsive::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.tt-no-block,
.tt-no-block * {
    pointer-events: none !important;
}
</style>